import { BILLING_PLANS } from "@/const/billing";
import type { PaidPlanTier } from "@/lib/types/billing.types";

// Client-safe mapping from a Paddle priceId to the `purchase` event parameters.
// BILLING_PLANS only holds NEXT_PUBLIC_* price ids (inlined client-side), so this
// is safe to import into client components. Returns undefined for unknown ids
// (e.g. enterprise, which has no client checkout and is tracked server-side).
export function resolvePurchaseParams(
  priceId: string | undefined | null
): { plan: PaidPlanTier; interval: "monthly" | "annual" } | undefined {
  if (!priceId) return undefined;

  for (const plan of Object.values(BILLING_PLANS)) {
    if (plan.tier === "free") continue;

    if (
      priceId === plan.paddleMonthlyPriceId ||
      priceId === plan.paddleMonthlyNoTrialPriceId
    ) {
      return { plan: plan.tier as PaidPlanTier, interval: "monthly" };
    }
    if (
      priceId === plan.paddleYearlyPriceId ||
      priceId === plan.paddleYearlyNoTrialPriceId
    ) {
      return { plan: plan.tier as PaidPlanTier, interval: "annual" };
    }
  }

  return undefined;
}
